var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasToday)?_c('span',{staticClass:"current-day-indicator js-current-day-indicator gl-absolute",style:(_vm.indicatorStyles)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }